export const SERVICE_RATE_PATTERN = /^(?:0|[1-9]\d{0,13})(?:\.\d{1,4})?$/;
export const SERVICE_UNITS = ["fixed", "hour", "day", "month", "item"];

export const exactServiceRate = service => String(service?.exactRate ?? service?.rate ?? "").trim();
export const validServiceRate = value => SERVICE_RATE_PATTERN.test(String(value).trim());
export const formatServiceRate = service => {
  const rate = exactServiceRate(service);
  if (!validServiceRate(rate) || !/^[A-Z]{3}$/.test(service?.currency || "")) return "Rate unavailable";
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: service.currency, maximumFractionDigits: 4,
  }).format(rate);
};

export const serviceInvoiceLine = (service, businessId, currency) => {
  if (!service?.id || service.archived || (service.issuerId && service.issuerId !== businessId)) {
    throw new Error("This service is not available to the selected issuing business.");
  }
  const rate = exactServiceRate(service);
  if (!validServiceRate(rate) || !SERVICE_UNITS.includes(service.unit)) {
    throw new Error("Reload the service to verify its rate and billing unit.");
  }
  return {
    serviceId: service.id,
    description: service.detail || service.description || service.name,
    unit: service.unit,
    quantity: "1",
    rate: service.currency === currency ? rate : "",
    currencyMismatch: service.currency !== currency,
  };
};
